import * as React from 'react';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Icon from '@mui/icons-material/HelpOutline';

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: { 
        backgroundColor: '#f5f5f9', color: 'rgba(0, 0, 0, 0.80)', maxWidth: 250, fontSize: theme.typography.pxToRem(12), border: '1px solid #dadde9', 
    },
  }));

export default function TooltipButton(props) {
    const { id, iconSx, iconButtonSx, title, message, onClickHandler } = props;
    return (      
        <HtmlTooltip
            title={
                <React.Fragment>
                    <Typography color="inherit">{title}</Typography>
                    {message}
                </React.Fragment>
            }>
            <IconButton id={id} onClick={onClickHandler} size="medium" sx={iconButtonSx}>
                <Icon sx={iconSx} />
            </IconButton>
        </HtmlTooltip>
    );
}